"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H = H;
exports.Section = Section;
exports.Heading = exports.HeadingLevelProvider = exports.HeadingLevelContext = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var HeadingLevelContext = (0, _react.createContext)(1);
exports.HeadingLevelContext = HeadingLevelContext;

var HeadingLevelProvider = function HeadingLevelProvider(_ref) {
  var children = _ref.children;
  return _react.default.createElement(HeadingLevelContext.Provider, {
    value: 1
  }, children);
};

exports.HeadingLevelProvider = HeadingLevelProvider;

function H(_ref2) {
  var props = Object.assign({}, _ref2);
  var level = Math.min(6, (0, _react.useContext)(HeadingLevelContext));
  var Element = "h".concat(level);
  return _react.default.createElement(Element, props);
}

var Heading = H;
exports.Heading = Heading;

function Section(_ref3) {
  var children = _ref3.children;
  var level = (0, _react.useContext)(HeadingLevelContext);
  return _react.default.createElement(HeadingLevelContext.Provider, {
    value: level + 1
  }, children);
}